export default {
  broadcastsFilterAriaLabel: 'Show all sent broadcasts or scheduled broadcasts',
  broadcastsFilterLabelAll: 'Sent',
  broadcastsFilterLabelScheduled: 'Scheduled',
  bulkMessagesLabel: 'Bulk Messages',
  noBroadcastsMessage: 'No Broadcasts',
  noScheduledMessage: 'No Scheduled Bulk Messages'
};
